import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-step-header',
  templateUrl: './step-header.component.html',
  styleUrls: ['./step-header.component.scss']
})
export class StepHeaderComponent implements OnInit {

  @Input() urlBack: string = '.';
  @Input() currentStep: number = 1;
  @Input() totalSteps: number = 4;

  constructor(private readonly route: ActivatedRoute, private readonly router: Router) { }

  ngOnInit(): void {
  }

  onBack(): void {
    this.router.navigate([this.urlBack], {relativeTo: this.route.parent});
  }

}
